import phoneImage from '../assets/orbisphone.png';
import './hero.css';
import { motion } from 'framer-motion';
export default function Hero() {
    return (
        <div className="hero">
            <div className='hero-wrapper'>
                <div className='hero-text-wrapper'>
                    <div className='text-container'>
                        <h1 className='header-text'>

                            <>Know <br />Your<br /> Impact.</>

                            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.5, type: "spring" }}>
                                Change It.
                            </motion.div>
                        </h1>
                        <text className='hero-text'>Orbis helps you track your daily carbon footprint and turn awareness into real, measurable action — for a healthier planet and a better future.</text>
                        <button
                            onClick={() => {
                                const el = document.getElementById('preregister-section');
                                if (el) el.scrollIntoView({ behavior: 'smooth' });
                            }}
                            className='preregister-button'>Pre-Register</button>
                    </div>
                </div>
                <motion.div className='hero-image' initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.5, type: "spring" }}>
                    {<img className='image' alt='phone with the orbis app installed' src={phoneImage}></img>}
                </motion.div>

                <button onClick={() => {
                    const el = document.getElementById('preregister-section');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                }} className='preregister-button-mobile'>Pre-Register</button>
            </div>

        </div>

    )
}